export enum LegalTermsIdEnum {
  LEGAL_TERMS = 'legal-terms',
  LEGAL_NOTICE = 'legal-notice',
  TERMS_AND_CONDITIONS = 'terms-and-conditions',
  DATA_PRIVACY_DISCLAIMERS = 'data-privacy-disclaimers',
}
